import Vue from 'vue'
import VueRouter from 'vue-router'
import Welcome from '../components/Welcome.vue'
import Sales from '../components/Sales.vue'
import Invoice from '../components/Invoice.vue'
import InvoiceList from '../components/InvoiceList.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Welcome
  },
  {
    path: '/sales',
    name: 'Sales',
    component: Sales
  },
  {
    path: '/invoice',
    name: 'InvoiceList',
    component: InvoiceList
  },
  {
    path: '/invoice/:id',
    name: 'Invoice',
    component: Invoice
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
